import { useQuery } from 'react-query'

import { defaultStaleTime } from '../../../config/queryClient'
import { QueryKeys } from '../../../enums/queryKeys'
import { BalanceModifier, fetchBalanceModifiers } from '../query-api'

interface UseFetchBalanceModifiersProps {
  modifierReference?: string
  enabled?: boolean
}

interface UseFetchBalanceModifiersResponse {
  balanceModifiers: BalanceModifier[]
  isLoading: boolean
}

export const useFetchBalanceModifiers = ({
  modifierReference,
  enabled = true,
}: UseFetchBalanceModifiersProps): UseFetchBalanceModifiersResponse => {
  const { data, isLoading } = useQuery(
    [QueryKeys.BalanceModifiers, modifierReference],
    () => fetchBalanceModifiers(modifierReference as string),
    {
      enabled: enabled && !!modifierReference,
      staleTime: defaultStaleTime,
    },
  )

  return {
    balanceModifiers: data?.balanceModifiers || [],
    isLoading,
  }
}
